import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "upload-form"
};
const _hoisted_2 = {
  class: "upload-list-dashboard-action"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = {
  key: 0,
  style: {
    "width": "10vw",
    "border-radius": "12px"
  },
  autoplay: "",
  muted: "",
  playsinline: "",
  loop: ""
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src", "onError"];
const _hoisted_7 = {
  class: "upload-list-item-content"
};
const _hoisted_8 = {
  key: 0,
  class: "upload-list-item-url"
};
const _hoisted_9 = {
  class: "upload-list-item-url-row"
};
const _hoisted_10 = {
  class: "upload-list-item-url-row"
};
const _hoisted_11 = {
  key: 1,
  class: "upload-list-item-progress"
};
const _hoisted_12 = {
  class: "upload-list-item-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CameraFilled = _resolveComponent("CameraFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_List = _resolveComponent("List");
  const _component_Checked = _resolveComponent("Checked");
  const _component_Failed = _resolveComponent("Failed");
  const _component_el_text = _resolveComponent("el-text");
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_button_group = _resolveComponent("el-button-group");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_Link = _resolveComponent("Link");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_card = _resolveComponent("el-card");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_upload, {
    class: _normalizeClass(["upload-card", {
      'is-uploading': $data.uploading,
      'upload-card-busy': $data.fileList.length
    }]),
    drag: "",
    multiple: "",
    "http-request": $options.uploadFile,
    onSuccess: $options.handleSuccess,
    "on-error": $options.handleError,
    "before-upload": $options.beforeUpload,
    "on-progress": $options.handleProgress,
    "file-list": $data.fileList,
    "show-file-list": false,
    accept: "image/*, video/*"
  }, {
    tip: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
      class: "el-upload__tip"
    }, "歡迎回到主頁", -1)])),
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "el-icon--upload",
      size: 100
    }, {
      default: _withCtx(() => [_createVNode(_component_CameraFilled, {
        color: "blanchedalmond"
      })]),
      _: 1
    }), _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "el-upload__text"
    }, [_createElementVNode("em", null, "拖拽"), _createTextVNode(), _createElementVNode("em", null, "點擊"), _createTextVNode(" 或 "), _createElementVNode("em", null, "Ctrl + V"), _createTextVNode("複製貼上")], -1))]),
    _: 1
  }, 8, ["class", "http-request", "onSuccess", "on-error", "before-upload", "on-progress", "file-list"]), _createVNode(_component_el_card, {
    class: _normalizeClass(["upload-list-card", {
      'upload-list-busy': $data.fileList.length
    }])
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["upload-list-container", {
        'upload-list-busy': $data.fileList.length
      }])
    }, [_createVNode(_component_el_scrollbar, {
      onScroll: $options.handleScroll,
      ref: "scrollContainer"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["upload-list-dashboard", {
          'list-scrolled': $data.listScrolled
        }])
      }, [_createVNode(_component_el_text, {
        class: "upload-list-dashboard-title"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_List)]),
          _: 1
        }), _createTextVNode(_toDisplayString($options.uploadingCount + $options.waitingCount) + " ", 1), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Checked)]),
          _: 1
        }), _createTextVNode(_toDisplayString($options.uploadSuccessCount) + " ", 1), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Failed)]),
          _: 1
        }), _createTextVNode(_toDisplayString($options.uploadErrorCount), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button_group, null, {
        default: _withCtx(() => [_createVNode(_component_el_tooltip, {
          disabled: $options.disableTooltip,
          content: "整体复制",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            round: "",
            onClick: $options.copyAll,
            alt: "整体复制"
          }, {
            default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
              icon: "copy"
            })]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_tooltip, {
          disabled: $options.disableTooltip,
          content: "失敗重试",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $options.retryError
          }, {
            default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
              icon: "redo"
            })]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_tooltip, {
          disabled: $options.disableTooltip,
          content: "清空列表",
          placement: "top",
          style: {
            "border": "none"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
              slot: "dropdown"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                onClick: $options.clearFileList
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("清空全部")])),
                _: 1
              }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                onClick: $options.clearSuccessList
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("清空已上傳")])),
                _: 1
              }, 8, ["onClick"])]),
              _: 1
            })]),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              round: "",
              style: {
                "outline": "none",
                "border-right": "none"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
                icon: "trash-alt"
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })])], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList.slice().reverse(), file => {
        return _openBlock(), _createElementBlock("div", {
          class: "upload-list-item",
          key: file.name,
          span: 8
        }, [_createElementVNode("a", {
          href: file.url,
          target: "_blank"
        }, [$options.isVideo(file.name) ? (_openBlock(), _createElementBlock("video", _hoisted_4, [_createElementVNode("source", {
          src: file.url,
          type: "video/mp4"
        }, null, 8, _hoisted_5), _cache[4] || (_cache[4] = _createTextVNode(" Your browser does not support the video tag. "))])) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          style: {
            "width": "10vw",
            "border-radius": "12px"
          },
          src: file.url,
          onError: $event => file.url = require('@/assets/404.png')
        }, null, 40, _hoisted_6))], 8, _hoisted_3), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_text, {
          class: "upload-list-item-name",
          truncated: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(file.name), 1)]),
          _: 2
        }, 1024), file.status === 'done' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_input, {
          modelValue: file.finalURL,
          "onUpdate:modelValue": $event => file.finalURL = $event,
          readonly: "",
          onClick: $options.selectAllText,
          size: $options.urlSize
        }, {
          prepend: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("URL")])),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onClick", "size"]), _createVNode(_component_el_input, {
          modelValue: file.mdURL,
          "onUpdate:modelValue": $event => file.mdURL = $event,
          readonly: "",
          onClick: $options.selectAllText,
          size: $options.urlSize
        }, {
          prepend: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("MarkDown")])),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onClick", "size"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
          modelValue: file.htmlURL,
          "onUpdate:modelValue": $event => file.htmlURL = $event,
          readonly: "",
          onClick: $options.selectAllText,
          size: $options.urlSize
        }, {
          prepend: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("HTML")])),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onClick", "size"]), _createVNode(_component_el_input, {
          modelValue: file.ubbURL,
          "onUpdate:modelValue": $event => file.ubbURL = $event,
          readonly: "",
          onClick: $options.selectAllText,
          size: $options.urlSize
        }, {
          prepend: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("BBCode")])),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onClick", "size"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_progress, {
          percentage: file.progreess,
          status: file.status,
          "show-text": false
        }, null, 8, ["percentage", "status"])]))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          circle: "",
          class: "upload-list-item-action-button",
          onClick: $event => $options.handleCopy(file)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Link)]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "danger",
          circle: "",
          class: "upload-list-item-action-button",
          onClick: $event => $options.handleRemove(file)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Delete)]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onClick"])])]);
      }), 128))]),
      _: 1
    }, 8, ["onScroll"])], 2)]),
    _: 1
  }, 8, ["class"])]);
}